import React from 'react'

const Experience = () => {
    return (
        <div id='education' className="experience">
            <div className ='d-flex justify-content-center my-5'>
              <h1>education</h1>
            </div>
            <div className="container experience-wrapper">
                <div className="timeline-block timeline-block-right">
                    <div className='marker'></div>
                     <div className='timeline-content'>
                         <h3>2006-2011</h3>
                         <h4>BS,Philology,Grodno State University(Belarus)</h4>
                
                     </div>
                </div>
                <div className="timeline-block timeline-block-left">
                    <div className='marker'></div>
                     <div className='timeline-content'>
                         <h3>2018</h3>
                         <h4>John Jay College of Criminal Justice, City University of New York</h4>
                         <p>Summer course focusing on how to effectively utilize social media</p>
                     </div>
                </div>
                <div className="timeline-block timeline-block-right">
                    <div className='marker'></div>
                     <div className='timeline-content'>
                         <h3>2016-2018</h3>
                         <h4>AAS, Game Design, Hostos Community College, City University of New York</h4>
                    
                     </div>
                </div>
                <div className="timeline-block timeline-block-left">
                    <div className='marker'></div>
                     <div className='timeline-content'>
                         <h3>2020</h3>
                         <h4>FULL STACK ACADEMY,Computer Science,Web Development</h4>
          
                     </div>
                </div>
                <div className="timeline-block timeline-block-right">
                    <div className='marker'></div>
                     <div className='timeline-content'>
                         <h3>2018-2021</h3>
                         <h4>BS, Computer Science, Brooklyn College, City University of New York</h4>
          
                     </div>
                </div>

            </div>
        </div>
    )
}

export default Experience
